<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->
 
<div class="endpoints-attention-total-wrapper stats-component">
  <div class="endpoints-attention-title">
    <span class="draggable">{{'endpoints-attention.title' | translate}}</span>
  </div>
  <!-- The draggable class above was moved outside of the async below so gridstack
        will see it, otherwise the entire component is draggable -->
  <div *ngrxLet="endpointsAttentionResult$ as endpointsAttentionResult" class="endpoints-attention-data-wrapper">
      <h2 *ngIf="chooseCustomer; else haveCustomerData" class="title">{{'dashboard.select-a-customer' | translate}}</h2>
      <ng-template #haveCustomerData>
          <div class="endpoints-attention-chart-wrapper">
              <div #containerRef class="chart-area" [ngStyle]="{'height': graphStyle}">
                  <div *ngIf="hasData(endpointsAttentionResult); else noData" class="chart">
                      <ngx-charts-pie-chart
                              [view]="[containerRef.offsetWidth, containerRef.offsetHeight]"
                              [results]="endpointsAttentionResult?.chartData"
                              [legend]="showLegend"
                              [labels]="showLabels"
                              [doughnut]="isDoughnut"
                              [legendPosition]="legendPosition"
                              legendTitle=""
                              arcWidth=".34"
                              (select)="onClick($event)"
                              [scheme]="colorScheme">
                      </ngx-charts-pie-chart>
                  </div>
                  <ng-template #noData>
                      <div *ngIf="endpointsAttentionResult" class="no-chart-data">
                          <span>{{'endpoints-attention.title' | translate}}</span>
                      </div>
                  </ng-template>
              </div>
              <div class="endpoints-attention-relative-changes-wrapper">
                  <div class="endpoints-attention-relative-changes-text">
                      <div>
                          <div class="sub-title">{{'endpoints-attention.subtitle' | translate}}</div>
                          <div>
                              <div class="data">{{'endpoints-attention.title' | translate}} - {{endpointsAttentionResult?.response.total}}</div>
                              <div class="data">{{'endpoints-attention.title' | translate}} - {{endpointsAttentionResult?.response.compliant}}</div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </ng-template>
  </div>
</div>